<template>
    <!-- Deal-status pill. Maps the deal vocabulary to tokens.css pill
         classes (lifted from ui.jsx StatusPill). -->
    <span class="pill" :class="pillClass">
        <span class="dot" />
        {{ label }}
    </span>
</template>

<script>
const MAP = {
    "Open":            ["pill--open",     "Open"],
    "Draft":           ["pill--draft",    "Draft"],
    "Overdue":         ["pill--overdue",  "Overdue"],
    "Complete":        ["pill--complete", "Complete"],
    "Canceled":        ["pill--canceled", "Canceled"],
    "Cancelled":       ["pill--canceled", "Cancelled"],
    "Replaced":        ["pill--canceled", "Replaced"],
    "Legacy mode":     ["pill--legacy",   "Legacy mode"],
    "On Hold":         ["pill--hold",     "On Hold"],
    "Retainer Ended":  ["pill--legacy",   "Retainer Ended"],
    "Service On Hold": ["pill--hold",     "Service on hold"],
    "Without sales":   ["pill--draft",    "Without sales"],
};

export default {
    name: "DealStatusPill",
    props: {
        status: { type: String, default: "" },
    },
    computed: {
        entry() {
            return MAP[this.status] || ["pill--draft", this.status || "—"];
        },
        pillClass() {
            return this.entry[0];
        },
        label() {
            return this.entry[1];
        },
    },
};
</script>
